import { render, staticRenderFns } from "./BlockNoAction.vue?vue&type=template&id=16c64be6&scoped=true&"
import script from "./BlockNoAction.vue?vue&type=script&lang=js&"
export * from "./BlockNoAction.vue?vue&type=script&lang=js&"
import style0 from "./BlockNoAction.vue?vue&type=style&index=0&id=16c64be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c64be6",
  null
  
)

export default component.exports